/*
 *
 * Dashboard reducer
 *
 */
import produce from 'immer';
import { DEFAULT_ACTION, PRESS_ORDER_LOADED } from './constants';

export const initialState = {
  pressPusher: {},
  pressExit1: {},
  pressExit2: {},
  pressChainAfterPusher: {},
  pressChainAfterRollers: {}
};

/* eslint-disable default-case, no-param-reassign */
const pressReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case PRESS_ORDER_LOADED: {
        console.log('#PRESS_ORDER_LOADED: ', action);
        draft[action.identifier] = action.item;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default pressReducer;
